import { container } from '@graphistry/falcor-react-redux';
import {
    toggleChatPanel,
    closeChat,
    setChatInput,
    sendChatMessage,
    receiveChatStart,
    receiveChatChunk,
    receiveChatThinking,
    promoteChatThinking,
    receiveChatDone,
    receiveChatError,
    receiveChatRunUpdate,
    receiveChatElement,
    clearChatContext,
    receiveChatContext,
    receiveChatStarters,
    receiveChatSkill,
    stopChat,
    setStreamingMode,
} from '@graphistry/viz/src/actions/chat';

import { ChatWidget } from '@graphistry/viz/src/components/chat/ChatWidget.tsx';

interface ChatData {
    enabled?: boolean;
    isOpen?: boolean;
    inputText?: string;
    isLoading?: boolean;
    currentResponseId?: number;
    runStartTime?: number;
    streamingMode?: boolean;
    messages?: unknown[];
    runNodes?: Record<string, unknown>;
    context?: unknown;
    starters?: unknown;
    startersError?: boolean;
    activeSkill?: string | null;
}

const ChatContainer = container({
    renderLoading: false,
    fragment: () => `{
        enabled,
        isOpen,
        inputText,
        isLoading,
        currentResponseId,
        runStartTime,
        streamingMode,
        messages,
        runNodes,
        context,
        starters,
        startersError,
        activeSkill
    }`,
    mapFragment: (data: ChatData, props: Record<string, unknown>) => ({ ...data, ...props }),
    dispatchers: {
        onToggleOpen: toggleChatPanel,
        onClose: closeChat,
        onSetInput: setChatInput,
        onSendMessage: sendChatMessage,
        onReceiveStart: receiveChatStart,
        onReceiveChunk: receiveChatChunk,
        onReceiveThinking: receiveChatThinking,
        onPromoteThinking: promoteChatThinking,
        onReceiveDone: receiveChatDone,
        onReceiveError: receiveChatError,
        onReceiveRunUpdate: receiveChatRunUpdate,
        onReceiveElement: receiveChatElement,
        onClearContext: clearChatContext,
        onReceiveContext: receiveChatContext,
        onReceiveStarters: receiveChatStarters,
        onReceiveSkill: receiveChatSkill,
        onStopChat: stopChat,
        onSetStreamingMode: setStreamingMode,
    }
});

export const Chat = ChatContainer(ChatWidget);
